import { render, staticRenderFns } from "./HomeClients.vue?vue&type=template&id=09d9d628&scoped=true&"
import script from "./HomeClients.vue?vue&type=script&lang=ts&"
export * from "./HomeClients.vue?vue&type=script&lang=ts&"
import style0 from "./HomeClients.vue?vue&type=style&index=0&id=09d9d628&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9d628",
  null
  
)

export default component.exports